import { ProcessedEvent } from '../../types'
import { CSSProperties, PureComponent } from 'react'
import styles from './SingleDayEvent.module.css'
import { EventItem } from './EventItem'

interface SingleDayEventProps {
  event: ProcessedEvent
  isSelected: boolean
  height: number
  top: number
  width: string
  distanceFromEdge: string
}

export class SingleDayEvent extends PureComponent<SingleDayEventProps> {
  render() {
    const {
      event,
      isSelected,
      height,
      top,
      width,
      distanceFromEdge,
    } = this.props

    const style: CSSProperties = {
      height,
      top,
      width,
      left: distanceFromEdge,
    }

    return (
      <div
        key={event.uid}
        className={styles.SingleDayEvent}
        style={style}
      >
        <EventItem event={event} isSelected={isSelected} />
      </div>
    )
  }
}
